import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tab } from 'semantic-ui-react';
import './tabs.less';

class Tabs extends Component {

  static propTypes = {
    panes: PropTypes.array.isRequired
  };

  render() {
    const panes = this.props.panes.map((i) => ({ menuItem: i.menuItem, render: () => <Tab.Pane>{i.component}</Tab.Pane> }));
    return (
      <div className="tabs-container">
        <Tab {...this.props} panes={panes} />
      </div>
    );
  }
}

export default Tabs;
